import { ChatReadStateResponse } from "../api/chat-response"

export type Reader = {
  userName?: string
  readAt: number
}

// Read state is a per-chat watermark, not a per-message flag, so a receipt is a comparison:
// someone has read a message when their lastReadAt is at or after the message's createdAt.
// Watermarks are parsed up front so checking a message is a number compare per reader.
export const makeReaders = (readStates: ChatReadStateResponse[]): Reader[] =>
  readStates.map(({ userName, lastReadAt }) => ({ userName, readAt: Date.parse(lastReadAt) }))

export const readersOf = (readers: Reader[], createdAt: string): (string | undefined)[] => {
  const sentAt = Date.parse(createdAt)

  return readers.filter((reader) => reader.readAt >= sentAt).map((reader) => reader.userName)
}
